<section id="content" *ngIf="lang">

  <div class="page page-profile">

    <div class="pageheader">

      <h2>{{ modalTitle }}
      </h2>

    </div>

    <!-- page content -->
    <div class="pagecontent">


      <!-- row -->
      <div class="row">

        <div class="col-md-12">

          <!-- tile -->
          <section class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body p-0">

              <div role="tabpanel">


                <!-- Tab panes -->
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">

                    <div class="wrap-reset">

                      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
                        <div *ngFor="let validation of msg">
                          <div class="error-message"
                            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
                            {{validation.message}}
                          </div>
                        </div>
                      </ng-template>

                      <form [formGroup]="createForm" (ngSubmit)="onSubmit()" class="form-validation">

                        <div class="row">

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.name }}</label>
                            <input type="text" class="form-control" formControlName="fname"
                              [ngClass]="formErrorClass(createForm.controls.fname, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.fname, value:createForm.controls.fname, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.surname }}</label>
                            <input type="text" class="form-control" formControlName="lname"
                              [ngClass]="formErrorClass(createForm.controls.lname, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.lname, value:createForm.controls.lname, submitted:createFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.company }}</label>
                            <input type="text" class="form-control" formControlName="company"
                              [ngClass]="formErrorClass(createForm.controls.company, createFormSubmitted)">



                          </div>


                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.telephone }}</label>
                            <input type="text" class="form-control" formControlName="telephone"
                              [ngClass]="formErrorClass(createForm.controls.telephone, createFormSubmitted)">


                          </div>


                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.email }}</label>
                            <input type="text" class="form-control" formControlName="e_mail"
                              [ngClass]="formErrorClass(createForm.controls.e_mail, createFormSubmitted)">

                          </div>



                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.fiscalCode }}</label>
                            <input type="text" class="form-control" formControlName="fiscal_code"
                              [ngClass]="formErrorClass(createForm.controls.fiscal_code, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.fiscal_code, value:createForm.controls.fiscal_code, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>


                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.taxCode }}</label>
                            <input type="text" class="form-control" formControlName="tax_code"
                              [ngClass]="formErrorClass(createForm.controls.tax_code, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.tax_code, value:createForm.controls.tax_code, submitted:createFormSubmitted }">
                            </ng-template>


                          </div>


                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.address }}</label>
                            <input type="text" class="form-control" formControlName="address"
                              [ngClass]="formErrorClass(createForm.controls.address, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.address, value:createForm.controls.address, submitted:createFormSubmitted }">
                            </ng-template>

                          </div>


                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.city }}</label>
                            <input type="text" class="form-control" formControlName="city"
                              [ngClass]="formErrorClass(createForm.controls.city, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.city, value:createForm.controls.city, submitted:createFormSubmitted }">
                            </ng-template>



                          </div>

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{ lang.province }}</label>
                            <input type="text" class="form-control" formControlName="state"
                              [ngClass]="formErrorClass(createForm.controls.state, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.state, value:createForm.controls.state, submitted:createFormSubmitted }">
                            </ng-template>



                          </div>


                          <div class="form-group col-sm-12">
                            <label for="first-name">{{ lang.zipcode }}</label>
                            <input type="text" class="form-control" formControlName="zip_code"
                              [ngClass]="formErrorClass(createForm.controls.zip_code, createFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:createFormErrorMsg.zip_code, value:createForm.controls.zip_code, submitted:createFormSubmitted }">
                            </ng-template>



                          </div>


                          <div class="col-sm-12" formArrayName="curricula_material">
                            <label>{{ lang.curriculumMaterial }}</label>
                            <div class="form-group row"
                              *ngFor="let link of curricula_material().controls; let i = index;" [formGroupName]="i">
                              <div class="col-sm-11">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment1($event,i)" formControlName="link" appFileDesign>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment(i)"
                                  *ngIf=" i!=(curricula_material().controls.length-1) ">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                                <button class="btn btn-primary pull-right" type="button" (click)="addAttachment()"
                                  *ngIf=" i==(curricula_material().controls.length-1) ">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="col-sm-12" formArrayName="curricula_material_uploaded">

                            <div class="form-group row"
                              *ngFor="let image of curricula_material_uploaded().controls; let i=index">
                              <div class="col-sm-11">
                                <input type="hidden" class="form-control" formControlName="{{i}}">
                                <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/academy/qteachers/{{image.value.split('/').pop()}}"
                                  target="_blank">{{image.value.split('/').pop()}}</a>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button"
                                  (click)="removeAttachmentUploaded(i)">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="col-sm-12" formArrayName="identity_papers">
                            <label>{{ lang.personalDocumentation }}</label>
                            <div class="form-group row" *ngFor="let link of identity_papers().controls; let i = index;"
                              [formGroupName]="i">
                              <div class="col-sm-11">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment2($event,i)" formControlName="link" appFileDesign>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment1(i)"
                                  *ngIf=" i!=(identity_papers().controls.length-1) ">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                                <button class="btn btn-primary pull-right" type="button" (click)="addAttachment1()"
                                  *ngIf=" i==(identity_papers().controls.length-1) ">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="col-sm-12" formArrayName="identity_papers_uploaded">

                            <div class="form-group row"
                              *ngFor="let image of identity_papers_uploaded().controls; let i=index">
                              <div class="col-sm-11">
                                <input type="hidden" class="form-control" formControlName="{{i}}">
                                <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/academy/qteachers/{{image.value.split('/').pop()}}"
                                  target="_blank">{{image.value.split('/').pop()}}</a>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button"
                                  (click)="removeAttachmentUploaded1(i)">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </div>
                            </div>
                          </div>



                          <div class="col-sm-12" formArrayName="contract_attch">
                            <label>{{ lang.contract }}</label>
                            <div class="form-group row" *ngFor="let link of contract_attch().controls; let i = index;"
                              [formGroupName]="i">
                              <div class="col-sm-11">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment3($event,i)" formControlName="link" appFileDesign>


                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment2(i)"
                                  *ngIf=" i!=(contract_attch().controls.length-1) ">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                                <button class="btn btn-primary pull-right" type="button" (click)="addAttachment2()"
                                  *ngIf=" i==(contract_attch().controls.length-1) ">
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <div class="col-sm-12" formArrayName="contract_attch_uploaded">

                            <div class="form-group row"
                              *ngFor="let image of contract_attch_uploaded().controls; let i=index">
                              <div class="col-sm-11">
                                <input type="hidden" class="form-control" formControlName="{{i}}">
                                <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/academy/qteachers/{{image.value.split('/').pop()}}"
                                  target="_blank">{{image.value.split('/').pop()}}</a>

                              </div>
                              <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button"
                                  (click)="removeAttachmentUploaded2(i)">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </div>
                            </div>
                          </div>


                          <div class="form-group col-sm-12">
                            <label for="first-name">{{ lang.generalNotes }}</label>
                            <textarea class="form-control" formControlName="general_notes"
                              [ngClass]="formErrorClass(createForm.controls.general_notes, createFormSubmitted)"></textarea>
                          </div>

                          <div class="col-sm-12" formArrayName="attachments">
                            <label>{{ lang.imagefiles }}</label>
                            <div class="form-group row" *ngFor="let link of attachments().controls; let i = index;"
                              [formGroupName]="i">
                              <div class="col-sm-11">
                                <input type="file" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment4($event,i)" formControlName="link" appFileDesign>


                              </div>

                            </div>
                          </div>

                          <div class="col-sm-12" formArrayName="attachments_uploaded">

                            <div class="form-group row"
                              *ngFor="let image of attachments_uploaded().controls; let i=index">
                              <div class="col-sm-11">
                                <input type="hidden" class="form-control" formControlName="{{i}}">
                                <input type="hidden" class="filestyle" data-buttonText="Choose file"
                                  (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">

                                <!-- <a (click)="imagePreview(image.value)">{{image.value.split('/').pop()}}</a> -->
                                <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/academy/qteachers/{{image.value.split('/').pop()}}"
                                  target="_blank">{{image.value.split('/').pop()}}</a>

                              </div>
                              <!-- <div class="col-sm-1">
                                <button class="btn btn-primary pull-right" type="button"
                                  (click)="removeAttachmentUploaded3(i)">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                              </div> -->
                            </div>
                          </div>

                          <div class="form-group col-sm-6">
                            <button type="submit" class="btn btn-primary">{{ lang.save }}</button>

                          </div>
                          <div class="form-group col-sm-4">
                          </div>
                          <div class="form-group col-sm-2">
                          </div>

                        </div>


                      </form>


                      <div class="panel panel-default" *ngIf="this.id">
                        <div class="panel-heading">
                          <a href="javascript:void(0);" (click)="add()" id="add_skills" style="margin-top: -6px;"
                            class="btn btn-light-grey btn-sm pull-right">
                            <i class="fa fa-plus fa-fw">
                            </i>{{ lang.addskills }} </a>
                          {{ lang.skills }}
                        </div>
                        <div class="panel-body ">
                          <div class="table-responsive">
                            <table class="table table-striped">
                              <thead>
                                <tr>
                                  <th>{{ lang.catalogueCode }}</th>
                                  <th>{{ lang.courseTitle }}</th>
                                  <th>{{ lang.category }}</th>
                                  <th>{{ lang.scopeofTeaching }}</th>
                                  <th>{{ lang.basicLevel }}</th>
                                  <th>{{ lang.currentLevel }}</th>
                                  <th>{{ lang.qualificationDate }}</th>
                                  <th>{{ lang.available }} </th>
                                  <th>{{ lang.action }}</th>
                                </tr>
                              </thead>
                              <tbody class="all_skills">
                                <tr *ngFor="let record of edit_skill_data let i = index"
                                  id="{{record.teacher_skillsId}}">
                                  <td>{{ record.code }}</td>
                                  <td>{{ record.name }}</td>
                                  <td>{{ record.category }}</td>
                                  <td>{{ record.require_level }}</td>
                                  <td>{{ record.level }}</td>
                                  <td>{{ record.current_level }}</td>
                                  <td>{{ record.qualification_date }}</td>
                                  <td>{{ record.status }}</td>

                                  <td>
                                    <div class="btn-group dropup">
      
                                      <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                        data-toggle="dropdown" aria-expanded="false"><i class="fa fa-tasks"></i></button>
      
                                      <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
      
                                          <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a (click)="edit(record.teacher_skillsId)" class="edit_action"><i
                                            class="fa fa-edit"></i> {{ lang.modify  }}</a></li>
      
                                            <li [ngClass]="(rolepermission=='1')?'overwrite_read':'overwrite_write'"><a class="delete_action" (click)="delete(this.id,record.teacher_skillsId)"><i
                                              class="fa fa-trash"></i> {{ lang.erase  }}</a></li>
                                      </ul>
                                    </div>
                                  </td>
                                </tr>


                              </tbody>
                            </table>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>



                </div>

              </div>

            </div>
            <!-- /tile body -->

          </section>
          <!-- /tile -->

        </div>


      </div>
      <!-- /page content -->

    </div>
  </div>

</section>